// client/src/utils/useInventoryEdits.js
//
// Centralized RPC commit logic for title, price, and quantity updates.
// Uses fetchWrapper for consistent authenticated Supabase RPC calls.

// client/src/utils/useInventoryEdits.js
//
// Centralized RPC commit logic for title, price, and quantity updates.
// Uses fetchWrapper for consistent authenticated Supabase RPC calls.

export default function useInventoryEdits({
  clientId,
  saleId,
  fetchWrapper
}) {
  // ---------------------------
  // Commit Title
  // ---------------------------
  async function commitTitle(itemId, newTitle) {

  if (!itemId) return;
  if (newTitle == null) return;

  const rpcEndpoint = "update_inventory_item_title";

  await fetchWrapper(
    `${process.env.REACT_APP_API_URL}/supabase/rpc/${rpcEndpoint}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        p_id: itemId,
        p_sale_id: saleId,
        p_client_id: clientId,
        p_title: newTitle
      })
    }
  );
}

  // ---------------------------
  // Commit Price
  // ---------------------------
 async function commitPrice(itemId, newPrice) {
  if (!itemId) return;
  if (newPrice === '') return;
  if (newPrice == null) return;

  const rpcEndpoint = "update_inventory_item_per_item_cost_estimate";

  await fetchWrapper(
    `${process.env.REACT_APP_API_URL}/supabase/rpc/${rpcEndpoint}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        p_client_id: clientId,                   // 1st
        p_id: itemId,                            // 2nd
        p_per_item_cost_estimate: String(newPrice), // 3rd
        p_sale_id: saleId                        // 4th
      })
    }
  );
}

  // ---------------------------
  // Commit Quantity
  // ---------------------------
  async function commitQty(itemId, newQty) {
  if (!itemId) return;
  if (!Number.isFinite(Number(newQty))) return;

  const rpcEndpoint = "update_inventory_item_quantity_estimate";

  await fetchWrapper(
    `${process.env.REACT_APP_API_URL}/supabase/rpc/${rpcEndpoint}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        p_id: itemId,                 // 1st
        p_sale_id: saleId,            // 2nd
        p_client_id: clientId,        // 3rd
        p_quantity_estimate: Number(newQty) // 4th
      })
    }
  );
}
// ---------------------------
// Commit Resale Positioning (text[] array)
// ---------------------------
async function commitResalePositioning(itemId, newValue) {
  if (!itemId) return;
  if (newValue == null || newValue.trim() === '') return;

  // Convert string to array: split on comma or newline
  const valueArray = newValue
    .split(/[\n,]+/)
    .map(s => s.trim())
    .filter(s => s.length > 0);

  const rpcEndpoint = "update_inventory_item_resale_positioning";
  await fetchWrapper(
    `${process.env.REACT_APP_API_URL}/supabase/rpc/${rpcEndpoint}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        p_id: itemId,
        p_sale_id: saleId,
        p_client_id: clientId,
        p_resale_positioning: valueArray
      })
    }
  );
}

// ---------------------------
// Commit Pricing Context (text[] array)
// ---------------------------
async function commitPricingContext(itemId, newValue) {
  if (!itemId) return;
  if (newValue == null || newValue.trim() === '') return;

  // Convert string to array: split on comma or newline
  const valueArray = newValue
    .split(/[\n,]+/)
    .map(s => s.trim())
    .filter(s => s.length > 0);

  const rpcEndpoint = "update_inventory_item_pricing_context";
  await fetchWrapper(
    `${process.env.REACT_APP_API_URL}/supabase/rpc/${rpcEndpoint}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        p_id: itemId,
        p_sale_id: saleId,
        p_client_id: clientId,
        p_pricing_context: valueArray
      })
    }
  );
}
  // ---------------------------
  // Commit ALL (title, price, qty)
  // ---------------------------
  async function commitAll(item) {
  if (!item) return;

  await commitTitle(item.id, item.title);
  await commitPrice(item.id, item.per_item_cost_estimate);
  await commitQty(item.id, item.quantity_estimate);
}

  return {
    commitTitle,
    commitPrice,
    commitQty,
    commitResalePositioning,
    commitPricingContext,
    commitAll
  };
}
